import { useEffect } from "react";
import TagManager from "react-gtm-module";
const GTM_ID = process.env.REACT_APP_GOOGLE_TAG_MANAGER || "GTM-K4B8VWPJ";

const GTMProvider = ({ children }) => {
  useEffect(() => {
    if (GTM_ID) {
      TagManager.initialize({ gtmId: GTM_ID });
    }
  }, []);

  return <>{children}</>;
};

export default GTMProvider;
